import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SourceTemplate, TextBook } from '@core/entities';
import { ISourceTemplate, ITextBook } from '@core/interfaces';

import { environment } from '@env/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SimulatorService {
  constructor(private http: HttpClient) {}

  getSimulators() {
    return this.http.get<any>(`${environment.apiUrl}simulations/`);
  }

  getSourceTemplates(id: number) {
    return this.http.get<any>(`${environment.apiUrl}simulations/${id}/game_templates/`).pipe(
      map((res: any) => ({
        ...res,
        results: res.results.map((template: ISourceTemplate) => new SourceTemplate(template)),
      }))
    );
  }

  getSimulationsTextbooks(id: number): Observable<TextBook[]> {
    return this.http
      .get<ITextBook[]>(`${environment.apiUrl}textbooks/?simulation=${id}`)
      .pipe(
        map((textbooks: ITextBook[]) =>
          textbooks.map((textbook: ITextBook) => new TextBook(textbook))
        )
      );
  }
}
